<template>
  <section class="hero is-hero-bar is-main-hero">
    <title-bar :title-stack="titleStack" />

    <div class="page-toolbar">
      <div class="page-toolbar-left">
        <span class="page-toolbar-title">
          <b-icon icon="email-outline" size="is-small" />
          Mesaje
        </span>
      </div>
      <div class="page-toolbar-right">
        <b-tooltip label="Reincarcare date" type="is-dark" position="is-bottom">
          <b-button icon-left="refresh" type="is-light" size="is-small" @click="reloadData" />
        </b-tooltip>
      </div>
    </div>

    <card-component
      class="has-table has-mobile-sort-spaced"
    >
      <messages-table
        :messages="messages"
        :isLoading="isLoading"
        :total="totalCount"
        :current-page="currentPage"
        @page-change="onPageChange"
      />
    </card-component>
  </section>
</template>

<script>
import Messages from "@/services/messages.service";
import CardComponent from "@/components/CardComponent";
import TitleBar from "@/components/TitleBar";
import MessagesTable from "../components/messages/messages-table.vue";

export default {
  name: "Messages",
  components: {
    TitleBar,
    CardComponent,
    MessagesTable,
  },
  data() {
    return {
      isLoading: true,
      messages: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
    };
  },
  created() {
    this.loadMessages();
  },
  methods: {
    async loadMessages() {
      const { getMessages } = Messages;
      this.isLoading = true;
      try {
        const response = await getMessages(this.currentPage, this.pageSize);
        const data = response.data;
        if (Array.isArray(data)) {
          this.messages = data;
          this.totalCount = data.length;
        } else {
          this.messages = data.items;
          this.totalCount = data.totalCount;
        }
      } finally {
        this.isLoading = false;
      }
    },
    reloadData() {
      this.loadMessages();
    },
    async onPageChange(page) {
      this.currentPage = page;
      this.loadMessages();
    },
  },
  computed: {
    titleStack() {
      return ["Mesaje"];
    },
  },
};
</script>

<style scoped>
.page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  gap: 1rem;
  flex-wrap: wrap;
}

.page-toolbar-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.page-toolbar-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.page-toolbar-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 600;
  font-size: 0.95rem;
  color: #363636;
}
</style>
